import React from 'react';
export function ExpertTestimonials() {
  const experts = [{
    name: 'Lena Gercke',
    title: 'Model & Unternehmerin',
    quote: 'Und weil mich immer noch Fragen zum von mir gesuchten Proteinpulver erreichen, mir wurde eins zugeschickt, was ich bis jetzt am besten finde, vom Geschmack her und auch von den Inhaltsstoffen. Habe bewusst nach einem Proteinshake gesucht, was kein Sojaprotein enthält und was ich einfach aufgießen kann ohne noch den Mixer anschmeißen zu müssen. Das hier ist mein Go-to-Shake geworden, werde davon satt, super verträglich und finde ihn tatsächlich auch sehr lecker!',
    headline: 'Mein Go-to-Shake'
  }, {
    name: 'Nora Weweler',
    title: 'Ernährungscoach & Autorin',
    quote: 'Als Ernährungsberaterin habe ich viele Proteinpulver getestet, aber das Pulver von eve nutrition ist mein Favorit. Eve nutrition bietet eine perfekt ausgewogene Nährstoffzusammensetzung mit allen essenziellen Aminosäuren und wichtigen Vitaminen und Mineralstoffen. Der Geschmack ist fantastisch, und im Gegensatz zu vielen anderen Sorten genieße ich das Pulver von eve wirklich.',
    headline: 'Perfekt ausgewogene Nährstoffzusammensetzung'
  }, {
    name: 'Victoria Engelhardt',
    title: 'Unternehmerin',
    quote: 'Ich finde dieses Proteinpulver absolut empfehlenswert. Das eve Pulver hat geschmacklich alle Alternativen übertroffen. Als stillende Mutter und Unternehmerin ist es in meinem Alltag der perfekte Helfer um auf mein Protein-Soll zu kommen und hat zudem noch wertvolle Vitamine und Mineralien. Ich finde auch toll, dass es so gut bekömmlich ist und nur ganz mild gesüßt.',
    headline: 'Mein neues Lieblingspulver'
  }];
  return <section className="py-16" data-id="element-47">
      <div className="max-w-4xl mx-auto" data-id="element-48">
        <div className="text-center mb-12" data-id="element-49">
          <span className="inline-block bg-emerald-100 text-emerald-700 text-sm font-medium py-1 px-3 rounded-full mb-3" data-id="element-50">
            Expertenmeinungen
          </span>
          <h3 className="text-4xl font-bold text-gray-800" data-id="element-51">
            Das sagen Expertinnen im Bereich Fitness, Abnehmen und
            Frauengesundheit über eve nutrition
          </h3>
        </div>
        <div className="space-y-8" data-id="element-52">
          {experts.map((expert, index) => <div key={index} className="flex flex-col md:flex-row gap-6 bg-gray-50 rounded-xl p-8 border border-gray-100 shadow-sm" data-id="element-53">
              <div className="md:w-1/4 flex-shrink-0" data-id="element-54">
                {index === 0 ? <div className="h-48 rounded-lg overflow-hidden mb-4" data-id="element-55">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/n1pZuBCfVUkJm1V7Cgi5wC/Kundenreferenz_Lena_Gercke.png" alt="Lena Gercke - Model & Unternehmerin" className="h-full w-full object-cover" data-id="element-56" />
                  </div> : index === 1 ? <div className="h-48 rounded-lg overflow-hidden mb-4" data-id="element-57">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pS835My6A53HK34Ldqmynw/Screenshot_2025-10-14_at_16.15.53.png" alt="Nora Weweler - Ernährungscoach & Autorin" className="h-full w-full object-cover" data-id="element-58" />
                  </div> : <div className="h-48 rounded-lg overflow-hidden mb-4" data-id="element-59">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vwZsQbT6Dj5jLUDrw92LNF/Screenshot_2025-10-14_at_16.16.15.png" alt="Victoria Engelhardt - Unternehmerin" className="h-full w-full object-cover" data-id="element-60" />
                  </div>}
                <div className="flex items-center justify-center" data-id="element-61">
                  <div className="flex" data-id="element-62">
                    {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-63">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-64" />
                      </svg>)}
                  </div>
                </div>
              </div>
              <div className="md:w-3/4" data-id="element-65">
                <div className="bg-white p-4 rounded-lg mb-4 inline-block" data-id="element-66">
                  <h4 className="text-xl font-semibold text-emerald-700" data-id="element-67">
                    {expert.headline}
                  </h4>
                </div>
                <p className="text-gray-600 mb-4 font-medium" data-id="element-68">
                  {expert.name},{' '}
                  <span className="text-emerald-600" data-id="element-69">{expert.title}</span>
                </p>
                <p className="text-gray-700 italic leading-relaxed" data-id="element-70">
                  "{expert.quote}"
                </p>
              </div>
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-71">
          <a href="https://weesesumecontasy.com/click/2" className="inline-block" data-id="element-72">
            <button className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-4 px-10 rounded-full transition duration-300 shadow-md text-lg" data-id="element-73">
              Zum Starter-Set Angebot
            </button>
          </a>
          <p className="text-sm text-gray-500 mt-3" data-id="element-74">
            Inkl. kostenlosem Versand & 30 Tage Geld-zurück-Garantie
          </p>
        </div>
      </div>
    </section>;
}